// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3af45ec6","453":"f45066d1","455":"ef6a2a17","977":"6484e390"}[chunkId] + ".chunk.js";
};